import { LockOutlined } from "@ant-design/icons";
import { Form, InputNumber } from "antd";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";

function FormDateMonthField({ fieldErrors, fieldId, name, description, max, min, isRequired, disabled, ...field }) {
    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={field.classifiers} orientation="horizontal" tagSummary={false} />
                    {field.isPII && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                </div>
            }
            tooltip={description}
            validateFirst={true}
            rules={[
                {
                    required: isRequired,
                    message: `Value is required`,
                },
                {
                    validator(_, value) {
                        if (value && value.toString().trim()) {
                            let monthValue = parseFloat(value);
                            if (isNaN(monthValue)) {
                                return Promise.reject(`Value should be a valid month value`);
                            }
                        }

                        return Promise.resolve();
                    },
                },
                {
                    type: "number",
                    min: min,
                    message: `Value should be greater than or equal to ${min}`,
                },
                {
                    type: "number",
                    max: max,
                    message: `Value should be less than or equal to ${max}`,
                },
            ]}
            {...fieldErrors}
        >
            <InputNumber min={min} max={max} disabled={disabled} />
        </Form.Item>
    );
}

export default FormDateMonthField;
